import { Pipe, PipeTransform } from '@angular/core';
import * as Moment from 'moment';
import { CONFIG } from '../constants/config.constants';

@Pipe({
  name: 'serverDatetimeToDisplayMonthPipe'
})
export class ServerDatetimeToDisplayMonthPipe implements PipeTransform {
	transform(value: any): string {
		if (value) {
			return Moment(value).format(CONFIG.monthFormat).valueOf();
		}

		return '';
	}
}
